import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Loader from './components/Loader';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { useTheme } from './hooks/useTheme';

export default function App() {
  const { isDark, toggleTheme } = useTheme();
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      <Loader onDone={() => setLoaded(true)} />

      <AnimatePresence>
        {loaded && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            className={isDark ? 'dark' : 'light'}
          >
            <Navbar isDark={isDark} toggleTheme={toggleTheme} />
            <main>
              <Hero isDark={isDark} />
              <About isDark={isDark} />
              <Skills isDark={isDark} />
              <Projects isDark={isDark} />
              <Experience isDark={isDark} />
              <Contact isDark={isDark} />
            </main>
            <Footer isDark={isDark} />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
